import { Observable, Observer } from "rxjs";
import { HTTP_METHOD } from "../../constants/http";
import { AxiosSubscriber } from "../AxiosSubscriber";
import { INotificationProviderModel } from "../../models";
import { PromisifiableBase } from "../Base/PromisifiableBase";

export class NotificationProvidersService extends PromisifiableBase {
  get url(): string {
    return "/NotificationProviders";
  }

  public select = (): Observable<INotificationProviderModel[]> =>
    new Observable(
      (observer: Observer<INotificationProviderModel[]>) =>
        new AxiosSubscriber(observer, {
          method: HTTP_METHOD.GET,
          url: `${this.url}/Select`,
        })
    );
}
